<template>
  <section-collapseable
    title="Leads"
    :sub-title="records.length"
    button-text="Attach Lead"
    @add="attachRecord"
  >
    <h3 class="lead_heading">Primary</h3>
    <p class="lead_description">All future inbound communications will be attached to this lead.</p>

    <div
      v-if="primaryRecord"
      class="flex flex-between flex-vertical-center"
    >
      <app-record
        :record="primaryRecord"
        :contact-id="contact.id"
        tooltip-position="is-left"
        class="flex-grow"
        include-role
      ></app-record>

      <button-outlined
        @click="removePrimaryRecord()"
        class="lead_button"
        color="is-dark"
      >Remove
      </button-outlined>
    </div>
    <p v-else class="lead_no_primary">This contact has no primary lead, all future inbound communications will not be attached to any lead.</p>

    <hr>

    <h3 class="lead_heading">Others</h3>

    <div
      v-for="record in otherRecords"
      :key="record.id"
      class="flex flex-between flex-vertical-center"
    >
      <app-record
        :record="record"
        :contact-id="contact.id"
        tooltip-position="is-left"
        class="flex-grow"
        include-role
      ></app-record>

      <button-outlined
        @click="makeRecordPrimary(record)"
        class="lead_button"
        color="is-dark"
      >Make Primary
      </button-outlined>
    </div>
  </section-collapseable>
</template>

<script>
import {appendModal} from "../../../services/modals";
import AttachLeadToContactModal from "../components/AttachLeadToContactModal";

export default {
  name: "ContactRecords",
  computed: {
    contact() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.contact : {
        id: null,
        primary_contact_id: null,
      };
    },
    records() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.records : [];
    },
    primaryRecord() {
      return this.records.find(record => record.id === this.contact.primary_record_id);
    },
    otherRecords() {
      return this.records.filter(record => record.id !== this.contact.primary_record_id);
    },
  },
  methods: {
    attachRecord() {
      appendModal(AttachLeadToContactModal, this);
    },
    makeRecordPrimary(record) {
      this.$api.contacts.setPrimaryRecord({id: this.contact.id, primary_record_id: record.id}).then(() => {
        this.$buefy.toast.open({message: "Primary Lead Saved", type: "is-success"});
      })
    },
    removePrimaryRecord() {
      this.$api.contacts.setPrimaryRecord({id: this.contact.id, primary_record_id: null}).then(() => {
        this.$buefy.toast.open({message: "Primary Lead Removed", type: "is-success"});
      })
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.lead_heading {
  margin: 10px 0 10px;
  color: $text-muted;
  font-size: 0.9rem;
  font-weight: bold;
  text-transform: uppercase;
}

.lead_description {
  margin: -4px 0 10px;
  color: $text-muted;
  font-size: 0.8rem;
}

.lead_no_primary {
  margin: 20px 0;
  color: $text-muted;
  font-style: italic;
  line-height: 1.3;
}

.lead_button {
  height: 1.5rem;
  margin-left: 10px;
  padding: 0 0.5rem;
  line-height: 1;
}
</style>
